import type { ChallengeList } from './schema';

/**
 * When a friend last answered (or bettered their answer to) one of the player's own challenges:
 * the CLUB tab's dot shows while this is newer than the player's last look at their challenges
 * (docs/ONLINE_UI.md, "badges only for people"). 0 when no one has.
 */
export function newestAnswerTo(list: ChallengeList, me: string): number {
  let newest = 0;
  for (const c of list.challenges) {
    if (c.from.player !== me) continue;
    for (const a of c.answers) if (a.player !== me && a.at > newest) newest = a.at;
  }
  return newest;
}
